import { render, staticRenderFns } from "./AllPostList.vue?vue&type=template&id=6ffed40a&scoped=true&"
import script from "./AllPostList.vue?vue&type=script&lang=js&"
export * from "./AllPostList.vue?vue&type=script&lang=js&"
import style0 from "./AllPostList.vue?vue&type=style&index=0&id=6ffed40a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffed40a",
  null
  
)

export default component.exports